// extracted by mini-css-extract-plugin
export default {"wrapper":"ScopeField__wrapper-FegFC","input":"ScopeField__input-XR3kC"};